//TODO: it will be neccessary to implement on common files to avoid code duplication(see getAdminViews and dependence files)
export const getAvailableEntityList = (list, mapped = true, userId = null) => {
	const newList = [];
	const addToList = (itemsToAdd) => newList.push(...itemsToAdd);
	getEntities(list, addToList, userId);
	return mapped ? newList.map(mapEntities) : newList;
};

export const getAdminAvailableEntityList = (list, userId) => {
	return getAvailableEntityList(list, true, userId);
};

const getEntities = (list, addToList, userId = null) => {
	list.forEach((item) => {
		if (item?.isEnabled) {
			if (userId === null) addToList([item]);
			if (item.entityAdmins.some((admins) => admins.userId === userId)) addToList([item]);
		}
		if (item?.nodes?.length > 0) getEntities(item.nodes, addToList, userId);
	});
};

const mapEntities = ({label, id, entityId, entityAdmins, contacts}) => ({
	label,
	value: id,
	id,
	entityId,
	entityAdmins,
	selected: false,
	disabled: false,
	contacts
});

export const getAdminViews = (filteredEntities, userGui) => {
	const adminObj = filteredEntities[0]?.entityAdmins?.find(({userId}) => userId === userGui);
	return adminObj?.views || getDashboardByUserId(filteredEntities[0]?.contacts, userGui);
};

const getDashboardByUserId = (users, userId) => {
	const user = users?.find((user) => user.userId === userId);
	return user?.dashboard || [];
};
